import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SEVerLetterEdit from "../../components/services/secondaryEducation/SEVerLetterEdit";

const SEVerLetterEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <SEVerLetterEdit />
    </PageWrapper>
  );
};

export default SEVerLetterEditPage;
